const TAB_SCHEDULE = 0;
const TAB_PATIENTS = 1;
const TAB_CLIENTS = 2;
const TAB_COMMUNICATIONS = 3;
const TAB_CONTACTS = 4;
const TAB_INVENTORY = 5;
const TAB_BILLING = 6;
const TAB_STAFF = 7;
const TAB_WELLNESS_PLAN = 8;
const TAB_CUSTOM = 9;
const TAB_SCHEDULED_REPORT = 10;

const TAB_STRING = {
    SCHEDULE: "schedule",
    PATIENTS: "patients",
    CLIENTS: "clients",
    COMMUNICATIONS: "communications",
    CONTACTS: "contacts",
    INVENTORY: "inventory",
    BILLING: "billing",
    STAFF: "staff",
    WELLNESS_PLAN: "wellness-plan",
    CUSTOM: "custom",
    SCHEDULED_REPORT: "scheduled-report"
};

const TABS = {
    "": TAB_SCHEDULE,
    [TAB_STRING.SCHEDULE]: TAB_SCHEDULE,
    [TAB_STRING.PATIENTS]: TAB_PATIENTS,
    [TAB_STRING.CLIENTS]: TAB_CLIENTS,
    [TAB_STRING.COMMUNICATIONS]: TAB_COMMUNICATIONS,
    [TAB_STRING.CONTACTS]: TAB_CONTACTS,
    [TAB_STRING.INVENTORY]: TAB_INVENTORY,
    [TAB_STRING.BILLING]: TAB_BILLING,
    [TAB_STRING.STAFF]: TAB_STAFF,
    [TAB_STRING.WELLNESS_PLAN]: TAB_WELLNESS_PLAN,
    [TAB_STRING.CUSTOM]: TAB_CUSTOM,
    [TAB_STRING.SCHEDULED_REPORT]: TAB_SCHEDULED_REPORT
};
export { TABS, TAB_STRING };
